import Modal, { ModalContainer } from '../common/Modal'
import { useSelector } from 'react-redux'; 
import { closeAllModal } from '@store/modalsSlise';
import { useDispatch } from 'react-redux';
import s from './index.module.css'
import classNames from 'classnames';
import { actions } from '@pages/Main/Timetable/actionsEnum';
import modalsList from './modalsList';
import IntersectionCheck from './Timetable/IntersectionCheck';
import EditLessonOrMeeting from './Timetable/EditLessonOrMeeting';
import ShowLessonOrMeeting from './Timetable/ShowLessonOrMeeting';
import AddingToPlanningTable from './Timetable/AddingToPlanningTable';
import TYPES from './TYPES';

const Modals = () => {
    const modals = useSelector((state) => state.modals);

    const dispatch = useDispatch();

    const handleCloseAllModal = () => {
        dispatch(closeAllModal());
    };

    const modalMinSize = modals.types.includes('bulkUpload') || 
          modals.types.includes(actions.addLessonOrMeeting) ||
          modals.types.includes(actions.intersectionCheck)   ||
          modals.types.includes(actions.editLessonOrMeeting) ||
          modals.types.includes(actions.showLessonOrMeeting) ||
          modals.types.includes(actions.addingToPlanningTable) || 
          modals.types.includes(TYPES.UPLOADING_FILES_TO_MEDIA_PLATFORMS) || 
          modals.types.includes(TYPES.EDIT_DIRECTION_COPY) || 
          modals.types.includes(TYPES.TIPTAP_RESIZE_IMAGE);

    const currentList = modalsList.filter(el => modals.types.includes(el.name));

    return (
        <Modal className={classNames(s.modal, {[s.modalMin]: modalMinSize})} 
               active={!!modals.types.length} 
               setActive={() => {handleCloseAllModal()}}
               style={{zIndex: '104'}}
        >
            <ModalContainer
                className={classNames({[s.modalContainerMin]: modalMinSize})}
                closeModal={handleCloseAllModal}
            >
                {
                    currentList.map((el, i) => {
                        const Component = el.component;
                        return (<Component
                            closeModal={handleCloseAllModal}
                            data={modals.data[el.name]}
                            key={i}
                        />)
                    })
                }
                {
                    modals.types.includes(actions.addingToPlanningTable) && (
                        <AddingToPlanningTable closeModal={handleCloseAllModal} data={modals.data[actions.addingToPlanningTable]} />
                    )
                }
            </ModalContainer>
        </Modal>
    )
}

export default Modals;